import React, {Component} from "react";
import { observer } from "mobx-react";
import {comma} from "../../../../../utils/Utils";
import OrderMenuSideDetailCheckItemView from "./OrderMenuSideDetailCheckItemView";

@observer
class OrderMenuSideDetailItemView extends Component {

    constructor(props){
        super(props);
        this.fn_soldOutLayer = this.props.fn_soldOutLayer;
    }

    render() {
        const { rootStore , obj, index} = this.props;
        const menuDetail = rootStore.menuStore.getMenuDetail;

        return(
            <div>
                <h6>{obj.sdsClsNm}</h6>
                <ul className="list_side">
                {
                    (Array.isArray(obj.sdsProdList) && obj.sdsProdList.length > 0)?
                    obj.sdsProdList.map((obj, index)=>(
                    <OrderMenuSideDetailCheckItemView key={index} index={index} rootStore={rootStore} obj={obj} fn_soldOutLayer={this.fn_soldOutLayer} />
                    )):null
                }
                </ul>
            </div>
        )
    }
}

export default OrderMenuSideDetailItemView;